import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Alert, Button, Card, CardBody, Container, Spinner, Table } from "reactstrap";

import { apiFetch, API } from "../../services/api";
import { readError, statusBadge, templateVariables } from "../../helpers/whatsappTemplates";

const Badge = ({ status }) => {
    const s = statusBadge(status);
    return <span style={{ display: "inline-flex", padding: "3px 9px", borderRadius: 999, fontSize: 12, fontWeight: 700, background: s.bg, color: s.color }}>● {s.label}</span>;
};

const Var = ({ v }) => <span style={{ display: "inline-block", padding: "1px 7px", borderRadius: 6, background: "#eef2ff", color: "#3346a8", fontWeight: 600, fontSize: 12.5, margin: "0 2px" }}>{v}</span>;

// Templates WhatsApp marketing (campagnes) : liste, statut Meta, accès à l'éditeur.
export function TemplatesList() {
    const [list, setList] = useState(null);
    const [campaigns, setCampaigns] = useState([]);
    const [error, setError] = useState(null);
    const [syncing, setSyncing] = useState(false);

    const load = () => {
        apiFetch(API.back + "/whatsapp-templates", { market: false })
            .then(async (res) => { if (!res.ok) throw new Error(await readError(res)); return res.json(); })
            .then((l) => setList(l.sort((a, b) => (a.system - b.system) || a.name.localeCompare(b.name))))
            .catch((e) => { setError("Templates indisponibles : " + e.message); setList([]); });
        apiFetch(API.back + "/whatsapp-campaigns", { market: false }).then((r) => (r.ok ? r.json() : [])).then(setCampaigns).catch(() => {});
    };
    useEffect(load, []);

    const sync = async () => {
        setSyncing(true);
        const res = await apiFetch(API.back + "/whatsapp-template-sync", { method: "POST", market: false });
        setSyncing(false);
        if (!res.ok) { setError(await readError(res)); return; }
        load();
    };

    const used = (name) => campaigns.filter((c) => c.templateName === name).length;

    return (
        <Container fluid className="p-0">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h1 className="h3 mb-0">Templates WhatsApp</h1>
                <div>
                    <Button color="light" className="mr-2" onClick={sync} disabled={syncing}>{syncing ? <Spinner size="sm" /> : "Rafraîchir les statuts"}</Button>
                    <Link to="/whatsapp/template/new/fr" className="btn btn-primary">+ Nouveau template</Link>
                </div>
            </div>
            {error && <Alert color="danger">{error}</Alert>}
            <Card>
                <CardBody className="p-0">
                    {!list ? <div className="p-3"><Spinner size="sm" /></div> : list.length === 0 ? <div className="p-3">Aucun template. <Link to="/whatsapp/template/new/fr">Créer le premier</Link>.</div> : (
                        <Table className="mb-0" hover responsive>
                            <thead><tr><th>Nom</th><th>Langue</th><th>Catégorie</th><th>Statut Meta</th><th>Variables</th><th>Campagnes</th><th /></tr></thead>
                            <tbody>
                                {list.map((t) => (
                                    <tr key={t.name + t.language}>
                                        <td><b>{t.name}</b>{t.system && <div className="text-muted small">Alertes (système)</div>}</td>
                                        <td>{t.language === "es" ? "🇪🇸 es" : "🇫🇷 fr"}</td>
                                        <td>{t.category === "UTILITY" ? "Utilitaire" : "Marketing"}</td>
                                        <td><Badge status={t.status} />{t.rejectedReason && <div className="small" style={{ color: "#a50e15" }}>Motif Meta : {t.rejectedReason}</div>}</td>
                                        <td>{templateVariables(t.body).map((v) => <Var key={v} v={v} />)}</td>
                                        <td>{t.system ? "—" : used(t.name)}</td>
                                        <td className="text-right">{t.system ? <span className="text-muted small">lecture seule</span>
                                            : <Link to={`/whatsapp/template/${t.name}/${t.language}`}>{t.status === "rejected" ? "Corriger" : t.status === "draft" ? "Modifier" : "Voir"}</Link>}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}
                </CardBody>
            </Card>
        </Container>
    );
}
